import { defineStore } from "pinia";
import router from "@app/router";
import { commClient } from "fw4-library";
import { SummitVersion } from "@app/version"
import { EnumFlowType } from "nlb-buy-go-library";

export interface IFlowData{
    isViewDataLoading: boolean;
    flowType: EnumFlowType | undefined;
}

export interface IProcessEndScreen{
    processEndTitle: string;
    processEndSubtitle: string;
    processEndIcon: string;
}

export interface ILoginForm{
    username: string;
    password: string;
    loginValid: boolean;
    loginError: string;
}

export interface IIncomeInsert {
    IsSP: boolean;
    IncomeData: {
        IncomeOne: number | null;
        IncomeTwo: number | null;
        IncomeThree: number | null;
        ConfirmSalary: boolean;
    }
}

export interface IDocumentSign {
    url: string;
    loaded: boolean;
    errorText: string;
}

export interface IEmailVerification{
    emailVerificationToken: string;
}

interface IPublicState{
    login: ILoginForm;
    Income: IIncomeInsert;
    docSign: IDocumentSign;
    emailVerification: IEmailVerification;
    processEndScreenData: IProcessEndScreen;
    flowData: IFlowData;
}

export const usePublicStore = defineStore('public', {
    state: (): IPublicState => {
        return {
            login: {
                username: "",
                password: "",
                loginValid: false,
                loginError: "",
            },
            Income: {
                IsSP: false,
                IncomeData: {
                    IncomeOne: null,
                    IncomeTwo: null,
                    IncomeThree: null,
                    ConfirmSalary: false
                }
            },
            docSign: {
                errorText: "",
                loaded: false,
                url: ""
            },
            emailVerification: {
                emailVerificationToken: ""
            },
            processEndScreenData: {
                processEndTitle: "",
                processEndSubtitle: "",
                processEndIcon: ""
            },
            flowData: {
                isViewDataLoading: false,
                flowType: undefined
            }
        }
    },
    actions: {
        async userLogin() {
            return new Promise((resolve, reject) => {
                const loginComplete = (Message: any): void => {
                    if (Message.loginValid === true) {
                        this.login.loginValid = true;
                        router.push({name: 'dashboard'});
                        resolve("Success");
                    } else {
                        this.login.password = "";
                        this.login.loginError = Message.loginError;
                        // reject(Error("Napačno uporabniško ime in/ali geslo."));
                        this.login.loginValid = false;
                    }
                };
    
                commClient.executeMethod("Login",
                    {
                        Username: this.login.username,
                        Password: this.login.password,
                        AppVer: SummitVersion
                    },
                    loginComplete);
            });
        },

        async userLogOut() {
            const logoutComplete = (Message: any): void => {
            };

            commClient.executeMethod("LogOut",
                {

                },
            logoutComplete);
        },
        
        loadSignatureInfo(type: string, id: string) {
            const signatureLoaded = (Message: any): void => {
                if (Message) {                     
                    this.docSign = Message as IDocumentSign;
                }
                else {
                }
            } 
            
            commClient.executeMethod("SignatureInfoLoad", {
                Type: type,
                SignToken: id
            }, signatureLoaded);
        },

        insertIncome(id: string){
            const insertComplete = (Message: any): void => {
                if (Message) {                     
                } 
                else {
                }
            } 
            
            commClient.executeMethod("InsertIncome", {       
                Id: id,
                Income: JSON.stringify(this.Income.IncomeData)
            }, insertComplete);
        },

        IncomeInsertGetSP(id: string){
            const getComplete = (Message: any): void => {
                if (Message) {
                    this.Income.IsSP = Message.IsSP as boolean;                   
                } 
                else {
                }
            } 

            commClient.executeMethod("sf.IncomeInsertGetSP", {       
                Guid: id,                
            }, getComplete);
        }
    },
});